/** RU/EN (adapted from istok-classroom): stored choice → navigator.language → en. */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { nsKey } from "../platform/storage";
import en from "./en.json";
import ru from "./ru.json";

export const LANGS = ["en", "ru"] as const;
export type Lang = (typeof LANGS)[number];

/** `<slug>.lang`; index.html reads the same key before first paint (STORY-138). */
const KEY = nsKey("lang", "app.lang");

export function storedLang(): Lang {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "en" || v === "ru") return v;
  } catch {
    /* ignore */
  }
  return navigator.language?.startsWith("ru") ? "ru" : "en";
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem(KEY, lang); // read by index.html before first paint, same key
  } catch {
    /* ignore */
  }
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ru: { translation: ru } },
  lng: storedLang(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const fmtDate = (iso: string | null | undefined, lang: Lang): string =>
  iso
    ? new Intl.DateTimeFormat(lang, { dateStyle: "medium", timeStyle: "short" }).format(
        new Date(iso.endsWith("Z") ? iso : `${iso}Z`),
      )
    : "—";

export default i18n;
